export default {
  // user settings
  settings: Object.assign({
    zoom: 12, // default map zoom
    center: [ 49.864716, 2.349014 ], // map center
    follow: false, // follow the user position on map
    tiles: 'basic', // tiles default style
    data: true, // use network data
    gps: 0, // 0 low precision 2 high
    nosleep: false, // keep the screen on
    km: true, // metric units
    cache: 3, // nb of days image are cached
    dark: false, // dark mode
    gtu: 0, // general terms of use version
    sub: false // subtitles
  }, JSON.parse(localStorage.getItem('settings'))),

  // lang
  lang: localStorage.getItem('lang') || 'en',
  langs: JSON.parse(localStorage.getItem('langs')) || [],

  // network state
  online: null,

  // map
  geoActive: false, // gps tracking
  geoLoading: false, // pending first gps response
  geoLocation: JSON.parse(localStorage.getItem('geo')) || null,
  geoErr: null, // gps error

  flyTo: null, // watched by the map, used to change the center

  // route
  markers: {}, // map object of markers
  markersLoading: false,
  swiper: [], // markers array in swiper
  highlight: JSON.parse(localStorage.getItem('highlight')) || null, // highlighted marker
  routeMarker: JSON.parse(localStorage.getItem('route')) || null, // marker where destination is set
  routePath: JSON.parse(localStorage.getItem('path')) || null // path from graphhopper
  // routePolyline: JSON.parse(localStorage.getItem('line')) || null, // itinerary
  // routeInstructions: JSON.parse(localStorage.getItem('instructions')) || null // text route instructions
}
